// // frontend/src/pages/Register.js
// import React, { useState } from 'react';
// import {
//   Container, TextField, Button, MenuItem, Select,
//   InputLabel, FormControl, Checkbox,
//   ListItemText, OutlinedInput, Box
// } from '@mui/material';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';



// const years = ['I','II', 'III', 'IV'];

// const yearToSems = {
//   I:['Sem-1','Sem-2'],
//   II: ['Sem-3', 'Sem-4'],
//   III: ['Sem-5', 'Sem-6'],
//   IV: ['Sem-7', 'Sem-8'],
// };

// const departments = ['AI', 'CSE', 'ENTC', 'Civil', 'ME'];
// // const subjects = ['AI', 'ML', 'DS', 'DBMS'];

// const subjects = [
//   // ✅ AI Department
//   { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
//   { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Physics' },
//   { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Programming Basics' },
//   { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
//   { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Data Structures' },
//   { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Engineering Chemistry' },
//   { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'DBMS' },
//   { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'OOP in Java' },
//   { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'Discrete Mathematics' },
//   { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Operating Systems' },
//   { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
//   { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'AI Foundations' },
//   { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Machine Learning' },
//   { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Deep Learning' },
//   { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'NLP' },
//   { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'Big Data Analytics' },
//   { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'AI Project' },
//   { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'Cloud Computing' },
//   { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'Capstone Project' },
//   { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'AI Ethics' },

//   // ✅ CSE Department
//   { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
//   { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Chemistry' },
//   { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'C Programming' },
//   { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
//   { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'Data Structures' },
//   { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'DBMS' },
//   { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'OS' },
//   { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
//   { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Web Development' },
//   { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Software Engineering' },
//   { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cloud Computing' },
//   { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cyber Security' },
//   { dept: 'CSE', year: 'IV', sem: 'Sem-7', name: 'Blockchain' },
//   { dept: 'CSE', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },

//   // ✅ ENTC Department
//   { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Basic Electronics' },
//   { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
//   { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Signals & Systems' },
//   { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
//   { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Digital Electronics' },
//   { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Microprocessors' },
//   { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Communication Engineering' },
//   { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Electromagnetics' },
//   { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'Embedded Systems' },
//   { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'VLSI Design' },
//   { dept: 'ENTC', year: 'III', sem: 'Sem-6', name: 'Internet of Things' },
//   { dept: 'ENTC', year: 'IV', sem: 'Sem-7', name: 'Wireless Networks' },
//   { dept: 'ENTC', year: 'IV', sem: 'Sem-8', name: 'Major Project' },

//   // ✅ Civil Department
//   { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
//   { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
//   { dept: 'Civil', year: 'I', sem: 'Sem-2', name: 'Surveying' },
//   { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Strength of Materials' },
//   { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Building Materials' },
//   { dept: 'Civil', year: 'II', sem: 'Sem-4', name: 'Hydraulics' },
//   { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Transportation Engineering' },
//   { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Geotechnical Engineering' },
//   { dept: 'Civil', year: 'III', sem: 'Sem-6', name: 'Structural Analysis' },
//   { dept: 'Civil', year: 'IV', sem: 'Sem-7', name: 'Irrigation Engineering' },
//   { dept: 'Civil', year: 'IV', sem: 'Sem-8', name: 'Project & Estimation' },

//   // ✅ Mechanical Department
//   { dept: 'ME', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
//   { dept: 'ME', year: 'I', sem: 'Sem-2', name: 'Engineering Drawing' },
//   { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Thermodynamics' },
//   { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Fluid Mechanics' },
//   { dept: 'ME', year: 'II', sem: 'Sem-4', name: 'Manufacturing Process' },
//   { dept: 'ME', year: 'III', sem: 'Sem-5', name: 'Machine Design' },
//   { dept: 'ME', year: 'III', sem: 'Sem-6', name: 'Heat Transfer' },
//   { dept: 'ME', year: 'IV', sem: 'Sem-7', name: 'Robotics' },
//   { dept: 'ME', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },
// ];



// const Register = () => {
//   const navigate = useNavigate();  // initialize

//   const [formData, setFormData] = useState({
//     username: '',
//     email: '',
//     password: '',
//     year: '',
//     sem: '',
//     department: '',
//     subjects: [],
//   });

//   const handleChange = (e) => {
//     const { name, value } = e.target;

//     // Reset sem when year changes
//     if (name === "year") {
//       setFormData({ ...formData, year: value, sem: '' });
//     } else {
//       setFormData({ ...formData, [name]: value });
//     }
//   };

//   const handleSubjectsChange = (e) => {
//     setFormData({ ...formData, subjects: e.target.value });
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();
//     try {
//       const response = await axios.post(
//         `${process.env.REACT_APP_API_URL}/api/auth/register`,
//         formData
//       );

//       alert(response.data.message || 'Registered successfully!');
//       navigate('/login');
//     } catch (err) {
//       if (err.response) {
//         alert(err.response.data.message);
//       } else {
//         alert('Error registering');
//       }
//       console.error(err);
//     }
//   };

//   return (

//     <Box
//       sx={{
//         display: 'flex',
//         justifyContent: 'center',
//         alignItems: 'center',
//         // minHeight: '100vh',
//         backgroundImage: 'url(https://source.unsplash.com/random?education)', // Background image
//         backgroundSize: 'cover',
//         backgroundPosition: 'center',
//       }}
//     >
//       <Container maxWidth="sm">
//         <Box
//           sx={{
//              mt: 6,
//             p: 4,
//             bgcolor: 'background.paper',
//             borderRadius: 2,
//             boxShadow: 3,
//             textAlign: 'center',
//             background: 'linear-gradient(145deg, #ffffff, #f0f0f0)', // Gradient background
//           }}
//         >
//           <form onSubmit={handleSubmit}>
//             <TextField
//               label="Username"
//               name="username"
//               value={formData.username}
//               onChange={handleChange}
//               fullWidth
//               required
//             />
//             <TextField sx={{ mt: 2 }}
//               type="password"
//               label="Password"
//               name="password"
//               value={formData.password}
//               onChange={handleChange}
//               fullWidth
//               required
//             />

//             <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Year</InputLabel>
//               <Select
//                 name="year"
//                 value={formData.year}
//                 onChange={handleChange}
//                 required
//               >
//                 {years.map((year) => (
//                   <MenuItem key={year} value={year}>{year}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Semester</InputLabel>
//               <Select
//                 name="sem"
//                 value={formData.sem}
//                 onChange={handleChange}
//                 required
//                 disabled={!formData.year} // disable until year is chosen
//               >
//                 {(yearToSems[formData.year] || []).map((sem) => (
//                   <MenuItem key={sem} value={sem}>{sem}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Department</InputLabel>
//               <Select
//                 name="department"
//                 value={formData.department}
//                 onChange={handleChange}
//                 required
//               >
//                 {departments.map((dept) => (
//                   <MenuItem key={dept} value={dept}>{dept}</MenuItem>
//                 ))}
//               </Select>
//             </FormControl>

//             {/* <FormControl fullWidth sx={{ mt: 2 }}>
//               <InputLabel>Subjects</InputLabel>
//               <Select
//                 multiple
//                 required
//                 name="subjects"
//                 value={formData.subjects}
//                 onChange={handleSubjectsChange}
//                 input={<OutlinedInput label="Subjects" />}
//                 renderValue={(selected) => selected.join(', ')}
//               >
//                 {subjects.map((subj) => (
//                   <MenuItem key={subj} value={subj}>
//                     <Checkbox checked={formData.subjects.indexOf(subj) > -1} />
//                     <ListItemText primary={subj} />
//                   </MenuItem>
//                 ))}
//               </Select>
//             </FormControl> */}

//             <FormControl fullWidth sx={{ mt: 2 }}>
//            <InputLabel>Subjects</InputLabel>
//             <Select
//               multiple
//               required
//               name="subjects"
//               value={formData.subjects}
//               onChange={handleSubjectsChange}
//               input={<OutlinedInput label="Subjects" />}
//               renderValue={(selected) => selected.join(', ')}
//               disabled={!formData.department || !formData.year || !formData.sem} // disable until all chosen
//               >
//                 {/* ✅ Filter subjects dynamically based on selection */}
//                 {subjects
//                   .filter(
//                     (s) =>
//                       s.dept === formData.department &&
//                       s.year === formData.year &&
//                         s.sem === formData.sem
//                     )
//                     .map((subj) => (
//                     <MenuItem
//                       key={`${subj.dept}-${subj.year}-${subj.sem}-${subj.name}`}
//                       value={subj.name}
//                     >
//                         <Checkbox checked={formData.subjects.indexOf(subj.name) > -1} />
//                         <ListItemText primary={subj.name} />
//                       </MenuItem>
//                     ))}
//                 </Select>
//               </FormControl>


//             <Button
//               type="submit"
//               variant="contained"
//               color="primary"
//               sx={{ mt: 3 }}
//             >
//               Register
//             </Button>
//           </form>
//         </Box>
//       </Container>
//     </Box>
//   );
// };

// export default Register;


import React, { useState } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';

const years = ['I','II', 'III', 'IV'];

const yearToSems = {
  I:['Sem-1','Sem-2'],
  II: ['Sem-3', 'Sem-4'],
  III: ['Sem-5', 'Sem-6'],
  IV: ['Sem-7', 'Sem-8'],
};

const departments = ['AI', 'CSE', 'ENTC', 'Civil', 'ME'];

const subjects = [
  // AI Department
  { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
  { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Physics' },
  { dept: 'AI', year: 'I', sem: 'Sem-1', name: 'Programming Basics' },
  { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
  { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Data Structures' },
  { dept: 'AI', year: 'I', sem: 'Sem-2', name: 'Engineering Chemistry' },
  { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'DBMS' },
  { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'OOP in Java' },
  { dept: 'AI', year: 'II', sem: 'Sem-3', name: 'Discrete Mathematics' },
  { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Operating Systems' },
  { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
  { dept: 'AI', year: 'II', sem: 'Sem-4', name: 'AI Foundations' },
  { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Machine Learning' },
  { dept: 'AI', year: 'III', sem: 'Sem-5', name: 'Deep Learning' },
  { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'NLP' },
  { dept: 'AI', year: 'III', sem: 'Sem-6', name: 'Big Data Analytics' },
  { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'AI Project' },
  { dept: 'AI', year: 'IV', sem: 'Sem-7', name: 'Cloud Computing' },
  { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'Capstone Project' },
  { dept: 'AI', year: 'IV', sem: 'Sem-8', name: 'AI Ethics' },

  // CSE Department
  { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
  { dept: 'CSE', year: 'I', sem: 'Sem-1', name: 'Chemistry' },
  { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'C Programming' },
  { dept: 'CSE', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
  { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'Data Structures' },
  { dept: 'CSE', year: 'II', sem: 'Sem-3', name: 'DBMS' },
  { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'OS' },
  { dept: 'CSE', year: 'II', sem: 'Sem-4', name: 'Computer Networks' },
  { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Web Development' },
  { dept: 'CSE', year: 'III', sem: 'Sem-5', name: 'Software Engineering' },
  { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cloud Computing' },
  { dept: 'CSE', year: 'III', sem: 'Sem-6', name: 'Cyber Security' },
  { dept: 'CSE', year: 'IV', sem: 'Sem-7', name: 'Blockchain' },
  { dept: 'CSE', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },

  // ENTC Department
  { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Basic Electronics' },
  { dept: 'ENTC', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
  { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Signals & Systems' },
  { dept: 'ENTC', year: 'I', sem: 'Sem-2', name: 'Maths-2' },
  { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Digital Electronics' },
  { dept: 'ENTC', year: 'II', sem: 'Sem-3', name: 'Microprocessors' },
  { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Communication Engineering' },
  { dept: 'ENTC', year: 'II', sem: 'Sem-4', name: 'Electromagnetics' },
  { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'Embedded Systems' },
  { dept: 'ENTC', year: 'III', sem: 'Sem-5', name: 'VLSI Design' },
  { dept: 'ENTC', year: 'III', sem: 'Sem-6', name: 'Internet of Things' },
  { dept: 'ENTC', year: 'IV', sem: 'Sem-7', name: 'Wireless Networks' },
  { dept: 'ENTC', year: 'IV', sem: 'Sem-8', name: 'Major Project' },

  // Civil Department
  { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
  { dept: 'Civil', year: 'I', sem: 'Sem-1', name: 'Maths-1' },
  { dept: 'Civil', year: 'I', sem: 'Sem-2', name: 'Surveying' },
  { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Strength of Materials' },
  { dept: 'Civil', year: 'II', sem: 'Sem-3', name: 'Building Materials' },
  { dept: 'Civil', year: 'II', sem: 'Sem-4', name: 'Hydraulics' },
  { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Transportation Engineering' },
  { dept: 'Civil', year: 'III', sem: 'Sem-5', name: 'Geotechnical Engineering' },
  { dept: 'Civil', year: 'III', sem: 'Sem-6', name: 'Structural Analysis' },
  { dept: 'Civil', year: 'IV', sem: 'Sem-7', name: 'Irrigation Engineering' },
  { dept: 'Civil', year: 'IV', sem: 'Sem-8', name: 'Project & Estimation' },

  // Mechanical Department
  { dept: 'ME', year: 'I', sem: 'Sem-1', name: 'Engineering Mechanics' },
  { dept: 'ME', year: 'I', sem: 'Sem-2', name: 'Engineering Drawing' },
  { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Thermodynamics' },
  { dept: 'ME', year: 'II', sem: 'Sem-3', name: 'Fluid Mechanics' },
  { dept: 'ME', year: 'II', sem: 'Sem-4', name: 'Manufacturing Process' },
  { dept: 'ME', year: 'III', sem: 'Sem-5', name: 'Machine Design' },
  { dept: 'ME', year: 'III', sem: 'Sem-6', name: 'Heat Transfer' },
  { dept: 'ME', year: 'IV', sem: 'Sem-7', name: 'Robotics' },
  { dept: 'ME', year: 'IV', sem: 'Sem-8', name: 'Final Year Project' },
];

const Register = () => {
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false);
  const [snackbar, setSnackbar] = useState({ open: false, message: '', severity: 'info' });

  const [formData, setFormData] = useState({
    username: '',
    email: '',
    password: '',
    year: '',
    sem: '',
    department: '',
    subjects: [],
  });

  const handleChange = (e) => {
    const { name, value } = e.target;

    // Reset sem when year changes
    if (name === "year") {
      setFormData({ ...formData, year: value, sem: '', subjects: [] });
    } else if (name === "sem") {
      setFormData({ ...formData, sem: value, subjects: [] });
    } else if (name === "department") {
      setFormData({ ...formData, department: value, subjects: [] });
    } else {
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubjectsChange = (subjectName) => {
    const currentSubjects = [...formData.subjects];
    const index = currentSubjects.indexOf(subjectName);
    
    if (index > -1) {
      currentSubjects.splice(index, 1);
    } else {
      currentSubjects.push(subjectName);
    }
    
    setFormData({ ...formData, subjects: currentSubjects });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    
    try {
      const apiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
      const response = await axios.post(`${apiUrl}/api/auth/register`, formData);

      setSnackbar({ 
        open: true, 
        message: response.data.message || 'Registered successfully! Redirecting to login...', 
        severity: 'success' 
      });
      
      setTimeout(() => navigate('/login'), 2000);
    } catch (err) {
      const errorMessage = err.response?.data?.message || 'Error registering. Please try again.';
      setSnackbar({ open: true, message: errorMessage, severity: 'error' });
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  const closeSnackbar = () => {
    setSnackbar({ ...snackbar, open: false });
  };

  const filteredSubjects = subjects.filter(
    (s) =>
      s.dept === formData.department &&
      s.year === formData.year &&
      s.sem === formData.sem
  );

  return (
    <div className="register-container">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600;700;800;900&display=swap');
        
        .register-container {
          min-height: 100vh;
          background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
          position: relative;
          overflow: hidden;
          display: flex;
          align-items: center;
          justify-content: center;
          padding: 2rem 1rem;
          font-family: 'Inter', -apple-system, BlinkMacSystemFont, sans-serif;
        }

        .register-container::before {
          content: '';
          position: absolute;
          top: 5%;
          right: 10%;
          width: 180px;
          height: 180px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: float 6s ease-in-out infinite;
        }

        .register-container::after {
          content: '';
          position: absolute;
          bottom: 10%;
          left: 15%;
          width: 120px;
          height: 120px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.05);
          animation: float 4s ease-in-out infinite;
          animation-delay: 2s;
        }

        @keyframes float {
          0%, 100% { transform: translateY(0px) rotate(0deg); }
          50% { transform: translateY(-20px) rotate(10deg); }
        }

        @keyframes slideIn {
          from { opacity: 0; transform: translateY(30px); }
          to { opacity: 1; transform: translateY(0); }
        }

        @keyframes spin {
          0% { transform: rotate(0deg); }
          100% { transform: rotate(360deg); }
        }

        @keyframes slideInFromBottom {
          from { 
            opacity: 0; 
            transform: translateY(100px); 
          }
          to { 
            opacity: 1; 
            transform: translateY(0); 
          }
        }

        .decorative-element-1 {
          position: absolute;
          top: 25%;
          left: 10%;
          width: 60px;
          height: 60px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.1);
          animation: pulse 4s ease-in-out infinite;
        }

        .decorative-element-2 {
          position: absolute;
          bottom: 20%;
          right: 20%;
          width: 80px;
          height: 80px;
          border-radius: 50%;
          background: rgba(255, 255, 255, 0.08);
          animation: pulse 3s ease-in-out infinite;
          animation-delay: 1s;
        }

        @keyframes pulse {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 0.8; transform: scale(1.2); }
        }

        .register-wrapper {
          max-width: 600px;
          width: 100%;
          position: relative;
          z-index: 1;
        }

        .register-card {
          background: rgba(255, 255, 255, 0.95);
          backdrop-filter: blur(20px);
          border-radius: 24px;
          padding: 3rem;
          border: 1px solid rgba(255, 255, 255, 0.2);
          box-shadow: 0 20px 40px rgba(0,0,0,0.1);
          animation: slideIn 0.8s ease-out;
          position: relative;
          overflow: hidden;
        }

        .register-card::before {
          content: '';
          position: absolute;
          top: 0;
          left: 0;
          right: 0;
          height: 4px;
          background: linear-gradient(90deg, #667eea, #764ba2, #f093fb, #f5576c);
          border-radius: 24px 24px 0 0;
        }

        .register-header {
          text-align: center;
          margin-bottom: 2.5rem;
        }

        .register-icon {
          width: 80px;
          height: 80px;
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          border-radius: 50%;
          display: flex;
          align-items: center;
          justify-content: center;
          margin: 0 auto 1.5rem;
          color: white;
          box-shadow: 0 8px 32px rgba(16, 185, 129, 0.4);
          transition: transform 0.3s ease;
        }

        .register-icon:hover {
          transform: scale(1.05);
        }

        .register-title {
          font-size: 2.5rem;
          font-weight: 900;
          color: #1f2937;
          margin-bottom: 0.5rem;
        }

        .register-subtitle {
          color: #6b7280;
          font-size: 1rem;
          font-weight: 500;
        }

        .form-group {
          margin-bottom: 2rem;
        }

        .form-row {
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 1rem;
          margin-bottom: 2rem;
        }

        .form-label {
          display: block;
          margin-bottom: 0.5rem;
          font-weight: 600;
          color: #374151;
          font-size: 0.95rem;
        }

        .form-input, .form-select {
          width: 100%;
          padding: 1.25rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(255, 255, 255, 0.9);
          backdrop-filter: blur(10px);
          font-family: inherit;
          font-size: 1rem;
          transition: all 0.3s ease;
          outline: none;
          box-sizing: border-box;
        }

        .form-input:focus, .form-select:focus {
          border-color: #667eea;
          box-shadow: 0 0 0 3px rgba(102, 126, 234, 0.1);
          background: white;
        }

        .form-input:disabled, .form-select:disabled {
          background: rgba(243, 244, 246, 0.5);
          color: #9ca3af;
          cursor: not-allowed;
        }

        .subjects-section {
          margin-top: 2rem;
        }

        .subjects-grid {
          display: grid;
          grid-template-columns: repeat(auto-fit, minmax(200px, 1fr));
          gap: 1rem;
          margin-top: 1rem;
          max-height: 300px;
          overflow-y: auto;
          padding: 1rem;
          border: 2px solid rgba(209, 213, 219, 0.3);
          border-radius: 12px;
          background: rgba(249, 250, 251, 0.5);
        }

        .subject-item {
          display: flex;
          align-items: center;
          gap: 0.75rem;
          padding: 0.75rem;
          border-radius: 8px;
          background: white;
          border: 1px solid rgba(209, 213, 219, 0.3);
          transition: all 0.3s ease;
          cursor: pointer;
        }

        .subject-item:hover {
          background: rgba(102, 126, 234, 0.05);
          border-color: rgba(102, 126, 234, 0.3);
        }

        .subject-checkbox {
          width: 18px;
          height: 18px;
          border: 2px solid #d1d5db;
          border-radius: 4px;
          cursor: pointer;
          transition: all 0.3s ease;
          position: relative;
        }

        .subject-checkbox.checked {
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          border-color: #059669;
        }

        .subject-checkbox.checked::after {
          content: '✓';
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          color: white;
          font-size: 12px;
          font-weight: bold;
        }

        .subject-label {
          font-size: 0.95rem;
          color: #374151;
          font-weight: 500;
        }

        .no-subjects-message {
          text-align: center;
          color: #6b7280;
          font-style: italic;
          padding: 2rem;
          background: rgba(243, 244, 246, 0.5);
          border-radius: 8px;
          margin-top: 1rem;
        }

        .register-btn {
          width: 100%;
          padding: 1.5rem 2rem;
          background: linear-gradient(45deg, #10b981 30%, #059669 90%);
          color: white;
          border: none;
          border-radius: 16px;
          font-size: 1.1rem;
          font-weight: 700;
          cursor: pointer;
          transition: all 0.3s ease;
          display: flex;
          align-items: center;
          justify-content: center;
          gap: 0.75rem;
          box-shadow: 0 6px 25px rgba(16, 185, 129, 0.4);
          margin-top: 2rem;
        }

        .register-btn:hover:not(:disabled) {
          transform: translateY(-3px);
          box-shadow: 0 12px 35px rgba(16, 185, 129, 0.5);
        }

        .register-btn:disabled {
          opacity: 0.7;
          cursor: not-allowed;
          transform: none;
        }

        .loading-spinner {
          width: 24px;
          height: 24px;
          border: 3px solid rgba(255, 255, 255, 0.3);
          border-top: 3px solid white;
          border-radius: 50%;
          animation: spin 1s linear infinite;
        }

        .brand-logo {
          position: absolute;
          top: 2rem;
          left: 2rem;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          color: white;
          font-weight: 700;
          font-size: 1.25rem;
        }

        .logo-icon {
          width: 40px;
          height: 40px;
          background: rgba(255, 255, 255, 0.2);
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .snackbar {
          position: fixed;
          bottom: 2rem;
          left: 50%;
          transform: translateX(-50%);
          padding: 1rem 2rem;
          border-radius: 12px;
          color: white;
          font-weight: 500;
          box-shadow: 0 8px 32px rgba(0,0,0,0.3);
          backdrop-filter: blur(10px);
          z-index: 1000;
          animation: slideInFromBottom 0.3s ease-out;
          display: flex;
          align-items: center;
          gap: 0.75rem;
          max-width: 400px;
        }

        .snackbar.success {
          background: rgba(16, 185, 129, 0.9);
        }

        .snackbar.error {
          background: rgba(239, 68, 68, 0.9);
        }

        .snackbar.warning {
          background: rgba(245, 158, 11, 0.9);
        }

        .snackbar.info {
          background: rgba(59, 130, 246, 0.9);
        }

        .snackbar-close {
          background: none;
          border: none;
          color: white;
          cursor: pointer;
          padding: 0.25rem;
          border-radius: 4px;
          opacity: 0.8;
        }

        .snackbar-close:hover {
          opacity: 1;
          background: rgba(255, 255, 255, 0.1);
        }

        /* Mobile responsiveness */
        @media (max-width: 768px) {
          .register-container {
            padding: 1rem 0.5rem;
          }
          
          .register-card {
            padding: 2rem 1.5rem;
          }

          .form-row {
            grid-template-columns: 1fr;
          }

          .subjects-grid {
            grid-template-columns: 1fr;
          }

          .brand-logo {
            position: relative;
            top: 0;
            left: 0;
            justify-content: center;
            margin-bottom: 2rem;
          }

          .snackbar {
            left: 1rem;
            right: 1rem;
            transform: none;
            max-width: none;
          }
        }
      `}</style>

      {/* Decorative Elements */}
      <div className="decorative-element-1"></div>
      <div className="decorative-element-2"></div>

      {/* Brand Logo */}
      <div className="brand-logo">
        <div className="logo-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
            <path d="M12,3L1,9L12,15L21,10.09V17H23V9M5,13.18V17.18L12,21L19,17.18V13.18L12,17L5,13.18Z"/>
          </svg>
        </div>
        SSPACE Assist
      </div>
      
      <div className="register-wrapper">
        <div className="register-card">
          <div className="register-header">
            <div className="register-icon">
              <svg width="36" height="36" viewBox="0 0 24 24" fill="currentColor">
                <path d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"/>
              </svg>
            </div>
            <div className="register-title">Join SSPACE Assist</div>
            <div className="register-subtitle">Create your account to get started</div>
          </div>

          <form onSubmit={handleSubmit}>
            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Username *</label>
                <input
                  type="text"
                  name="username"
                  className="form-input"
                  value={formData.username}
                  onChange={handleChange}
                  placeholder="Enter your username"
                  required
                />
              </div>

              <div className="form-group">
                <label className="form-label">Email *</label>
                <input
                  type="email"
                  name="email"
                  className="form-input"
                  value={formData.email}
                  onChange={handleChange}
                  placeholder="Enter your email"
                  required
                />
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Password *</label>
              <input
                type="password"
                name="password"
                className="form-input"
                value={formData.password}
                onChange={handleChange}
                placeholder="Create a secure password"
                required
              />
            </div>

            <div className="form-row">
              <div className="form-group">
                <label className="form-label">Year *</label>
                <select
                  name="year"
                  className="form-select"
                  value={formData.year}
                  onChange={handleChange}
                  required
                >
                  <option value="">Select Year</option>
                  {years.map((year) => (
                    <option key={year} value={year}>Year {year}</option>
                  ))}
                </select>
              </div>

              <div className="form-group">
                <label className="form-label">Semester *</label>
                <select
                  name="sem"
                  className="form-select"
                  value={formData.sem}
                  onChange={handleChange}
                  disabled={!formData.year}
                  required
                >
                  <option value="">Select Semester</option>
                  {(yearToSems[formData.year] || []).map((sem) => (
                    <option key={sem} value={sem}>{sem}</option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-group">
              <label className="form-label">Department *</label>
              <select
                name="department"
                className="form-select"
                value={formData.department}
                onChange={handleChange}
                required
              >
                <option value="">Select Department</option>
                {departments.map((dept) => (
                  <option key={dept} value={dept}>{dept}</option>
                ))}
              </select>
            </div>

            <div className="subjects-section">
              <label className="form-label">
                Subjects * 
                {formData.subjects.length > 0 && (
                  <span style={{ color: '#10b981', marginLeft: '0.5rem' }}>
                    ({formData.subjects.length} selected)
                  </span>
                )}
              </label>
              
              {!formData.department || !formData.year || !formData.sem ? (
                <div className="no-subjects-message">
                  Please select department, year, and semester first to see available subjects.
                </div>
              ) : filteredSubjects.length === 0 ? (
                <div className="no-subjects-message">
                  No subjects available for the selected combination.
                </div>
              ) : (
                <div className="subjects-grid">
                  {filteredSubjects.map((subject, index) => (
                    <div
                      key={`${subject.dept}-${subject.year}-${subject.sem}-${subject.name}`}
                      className="subject-item"
                      onClick={() => handleSubjectsChange(subject.name)}
                    >
                      <div 
                        className={`subject-checkbox ${formData.subjects.includes(subject.name) ? 'checked' : ''}`}
                      ></div>
                      <span className="subject-label">{subject.name}</span>
                    </div>
                  ))}
                </div>
              )}
            </div>

            <button
              type="submit"
              className="register-btn"
              disabled={loading || formData.subjects.length === 0}
            >
              {loading ? (
                <>
                  <div className="loading-spinner"></div>
                  Creating Account...
                </>
              ) : (
                <>
                  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
                    <path d="M15,14C12.33,14 7,15.33 7,18V20H23V18C23,15.33 17.67,14 15,14M6,10V7H4V10H1V12H4V15H6V12H9V10M15,12A4,4 0 0,0 19,8A4,4 0 0,0 15,4A4,4 0 0,0 11,8A4,4 0 0,0 15,12Z"/>
                  </svg>
                  Create Account
                </>
              )}
            </button>
          </form>
        </div>
      </div>

      {/* Snackbar Notification */}
      {snackbar.open && (
        <div className={`snackbar ${snackbar.severity}`}>
          <span>{snackbar.message}</span>
          <button className="snackbar-close" onClick={closeSnackbar}>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="currentColor">
              <path d="M19,6.41L17.59,5L12,10.59L6.41,5L5,6.41L10.59,12L5,17.59L6.41,19L12,13.41L17.59,19L19,17.59L13.41,12L19,6.41Z"/>
            </svg>
          </button>
        </div>
      )}
    </div>
  );
};

export default Register;


